module.exports = __webpack_public_path__ + "img/zoom-plus.f0f0fec5.svg";